import analytics from "./analytics"

export default () => {
  // disables submit button by default
  const submitBtn = document.querySelector("#Form_RateCalculationForm_action_CalculationTrigger")

  if (submitBtn) {
    submitBtn.disabled = true

    // listens for changes to the TA text field
    document
      .querySelector("select#Form_RateCalculationForm_TerritorialAuthorityID")
      .addEventListener("change", function() {
        populatePropertyOptions()
        checkOKForSubmit()
      })

    // listens for changes on year/tranche selector field
    document.querySelector("select#Form_RateCalculationForm_Tranche").addEventListener("change", function() {
      populatePropertyOptions()
      checkOKForSubmit()
    })

    // listens for changes on property type selector field
    document.querySelector("select#Form_RateCalculationForm_RatePropertyTypeID").addEventListener("change", function() {
      checkOKForSubmit()
    })

    document.getElementById("Form_RateCalculationForm_RateableValue").addEventListener("keyup", checkOKForSubmit)

    submitBtn.addEventListener("click", function(event) {
      event.preventDefault()

      event.target.disabled = true

      submitForm().finally(() => {
        event.target.disabled = false
      })
    })
  }

  async function submitForm() {
    const resultElem = document.querySelector("#Form_RateCalculationForm_Result")
    resultElem.innerHTML = ""

    const noResultElem = document.querySelector("#Form_RateCalculationForm_NoResult")

    const url = `/api/v1/rates/calculate`

    const form = document.querySelector("#Form_RateCalculationForm")
    const data = Array.from(new FormData(form)).reduce((params, field) => {
      params[field[0]] = field[1]
      return params
    }, {})

    analytics.trackEvent({ event: "calculate_rates" })

    if (data["EmailAddress"] !== "") {
      analytics.trackEvent({ event: "email_rates_calculation" })
    }

    return new Promise(async (resolve, reject) => {
      await fetch(url, {
        method: "post",
        dataType: "json",
        contentType: "application/json",
        body: JSON.stringify(data),
      }).then(async response => {
        if (response.ok) {
          const result = await response.text()
          resultElem.innerHTML = result
          noResultElem.style = "display: none;"

          addEmailListener()

          return resolve()
        } else {
          noResultElem.style = "display: block;"

          return reject()
        }
      })
    })
  }

  function addEmailListener() {
    let emailBtn = document.querySelector("#Form_RatesCalculationEmailForm_action_sendCalculationEmail")

    if (!emailBtn) {
      return
    }

    const clone = emailBtn.cloneNode(true)

    // replace with clone to remove existing listeners
    emailBtn.parentNode.replaceChild(clone, emailBtn)
    emailBtn = clone

    emailBtn.addEventListener("click", function(event) {
      event.preventDefault()

      const email = document.querySelector("#Form_RatesCalculationEmailForm_EmailAddress")
      const warning = email.parentNode.querySelector(".error")
      if (!email.value) {
        if (!warning) {
          const validationWarning = document.createElement("div")
          validationWarning.classList.add("error")
          validationWarning.textContent = "Email address required"
          email.parentNode.appendChild(validationWarning)
        }
        return
      } else if (warning) {
        warning.remove()
      }

      event.target.disabled = true

      sendEmail()
    })
  }

  async function sendEmail() {
    const form = document.querySelector("#Form_RatesCalculationEmailForm")
    const params = new URLSearchParams(new FormData(form))

    const url = `/api/v1/rates/sendCalculationEmail?${params.toString()}`

    analytics.trackEvent({ event: "email_rates_calculation" })

    await fetch(url)

    const emailBtn = document.getElementById("Form_RatesCalculationEmailForm_action_sendCalculationEmail")

    emailBtn.value = "...Email sent!"
    emailBtn.disabled = true

    setTimeout(function() {
      emailBtn.value = "Yes, please email this to me"
      emailBtn.disabled = false
    }, 5000)
  }

  // populates Property types field upon TA change
  async function populatePropertyOptions() {
    const territoryId = document
      .querySelector("select#Form_RateCalculationForm_TerritorialAuthorityID option:checked")
      .getAttribute("value")
    const yearId = document
      .querySelector("select#Form_RateCalculationForm_Tranche option:checked")
      .getAttribute("value")

    if (territoryId.length > 0 && yearId.length > 0) {
      const propertyTypeField = document.querySelector("select#Form_RateCalculationForm_RatePropertyTypeID")

      // remove existing options
      propertyTypeField.selectr.removeAll()
      propertyTypeField.innerHTML = ""
      propertyTypeField.disabled = false

      const params = new URLSearchParams({
        TerritoryID: territoryId,
        YearID: yearId,
      })

      const url = `/api/v1/rates/propertyTypes?${params.toString()}`

      return new Promise(async (resolve, reject) => {
        await fetch(url).then(async response => {
          if (response.ok) {
            const data = await response.json()

            const options = [
              {
                ID: 0,
                Name: "(Select a property type)",
              },
              ...data,
            ]

            options.forEach(option => {
              const optionElem = document.createElement("option")
              optionElem.value = option.ID
              optionElem.textContent = option.Name
              propertyTypeField.appendChild(optionElem)

              // add option to selectr abstraction of the select component - see forms.js
              propertyTypeField.selectr.add({
                value: option.ID,
                text: option.Name,
              })
            })

            propertyTypeField.selectr.setValue(0)

            return resolve()
          } else {
            return reject()
          }
        })
      })
    }
  }

  // enables submit button when all fields are populated or selected
  function checkOKForSubmit() {
    const territoryValue = document
      .querySelector("select#Form_RateCalculationForm_TerritorialAuthorityID")
      .selectr.getValue()
    const yearValue = document.querySelector("select#Form_RateCalculationForm_Tranche").selectr.getValue()
    const propertyTypeValue = document
      .querySelector("select#Form_RateCalculationForm_RatePropertyTypeID")
      .selectr.getValue()
    const rateValue = document.getElementById("Form_RateCalculationForm_RateableValue").value

    if (territoryValue.length > 0 && yearValue.length > 0 && propertyTypeValue > 0 && rateValue > 0) {
      document.getElementById("Form_RateCalculationForm_action_CalculationTrigger").disabled = false
    } else {
      document.getElementById("Form_RateCalculationForm_action_CalculationTrigger").disabled = true
    }
  }
}
